// Spanish (ES) — neutral international Spanish, professional fitness-industry
// register. AI-prepared, pending native review before production.
export default {
  "seo.title": "Abra Su Gimnasio — Equipamiento Directo de Fábrica | YANRE FITNESS EUROPE",
  "seo.description": "De estudios privados a grandes instalaciones comerciales — equipamiento profesional YANRE, consultoría de proyecto personalizada, logística internacional y posventa con respaldo de fábrica.",

  "nav.Why Fitness": "Por Qué Fitness",
  "nav.Why YANRE": "Por Qué YANRE",
  "nav.How It Works": "Cómo Funciona",
  "nav.Real Projects": "Proyectos Reales",
  "nav.visitWebsite": "Visitar Sitio Web",
  "header.cta": "Iniciar Su Proyecto",

  "hero.label": "Abra Su Gimnasio",
  "hero.line1": "Construya su gimnasio.",
  "hero.line2a": "Compre directamente al",
  "hero.line2b": "fabricante.",
  "hero.copy": "Desde estudios privados hasta grandes instalaciones comerciales — equipamiento profesional YANRE, consultoría de proyecto personalizada, apoyo logístico internacional y posventa con respaldo de fábrica.",
  "hero.ctaPrimary": "Iniciar Mi Proyecto de Gimnasio",
  "hero.ctaSecondary": "Hablar con un Especialista",
  "hero.trust.0": "Directo de Fábrica",
  "hero.trust.1": "Consultoría de Proyecto",
  "hero.trust.2": "Logística Internacional",
  "hero.trust.3": "Garantía de Fábrica",

  "marquee.Precision": "Precisión",
  "marquee.Performance": "Rendimiento",
  "marquee.Confidence": "Confianza",
  "marquee.Engineering": "Ingeniería",
  "marquee.Since 1997": "Desde 1997",

  "strip.1": "¿Listo para hablar de su proyecto?",
  "strip.2": "¿Sabe lo que necesita? Hablemos.",
  "strip.3": "¿Ya lo vio todo? Inicie su proyecto.",
  "strip.cta": "Iniciar Su Proyecto",

  "label.Why Invest in Fitness": "Por Qué Invertir en Fitness",
  "label.Fitness Market Proof": "Prueba del Mercado del Fitness",
  "label.New to Fitness? That's OK.": "¿Nuevo en el Fitness? No Hay Problema.",
  "label.Factory Direct": "Directo de Fábrica",
  "label.Factory Direct Purchase Process": "Proceso de Compra Directo de Fábrica",
  "label.Featured Equipment": "Equipamiento Destacado",
  "label.Engineered Differently": "Ingeniería Diferente",
  "label.Built Around Your Business": "Construido alrededor de Su Negocio",
  "label.Why YANRE FITNESS": "Por Qué YANRE FITNESS",
  "label.The Founder": "El Fundador",
  "label.YANRE Gyms Around the World": "Gimnasios YANRE en el Mundo",
  "label.International Logistics": "Logística Internacional",
  "label.After-Sales & Warranty": "Posventa y Garantía",
  "label.Start Your Project": "Inicie Su Proyecto",
  "label.Milestones": "Hitos",
  "label.Engineering Philosophy": "Filosofía de Ingeniería",

  "wa.title": "WhatsApp",
  "wa.subtitle": "Hablar con un Especialista",

  "footer.contact": "Contacto",
  "footer.legal": "Legal",
  "footer.privacy": "Política de Privacidad",
  "footer.cookies": "Política de Cookies",
  "footer.terms": "Términos",
  "footer.visit": "Visitar el Sitio Web de YANRE FITNESS EUROPE",

  "step.1": "Proyecto",
  "step.2": "Espacio",
  "step.3": "Inversión",
  "step.4": "Contacto",
  "step.5": "Necesidades del Proyecto",
  "step.6": "Logística",
  "step.7": "Compra",
  "step.8": "Su Rol",
  "step.9": "Ubicación",
  "step.10": "Contacto",
  "step.11": "Información Final",
  "form.progress": "Paso",
  "form.title1": "Construya el proyecto",
  "form.title2": "de su gimnasio.",
  "form.subtitle": "Cuéntenos qué está planeando. Le ayudamos a construir la solución de equipamiento adecuada.",
  "form.intro.sub1": "4 PASOS RÁPIDOS.",
  "form.intro.sub2": "UNA SOLUCIÓN COMPLETA PARA TU GIMNASIO.",
  "form.intro.support": "Cuéntanos tu proyecto en solo 4 pasos sencillos. Nuestro equipo entenderá tus necesidades y te ayudará a construir la solución adecuada — con suministro directo de fábrica de YANRE FITNESS China, consultoría profesional y soporte posventa.",
  "form.intro.minute": "1 MINUTO PARA COMPLETAR",
  "form.back": "Atrás",
  "form.continue": "Continuar",
  "form.submit": "Recibir Mi Proyecto de Gimnasio",
  "form.sending": "Enviando…",

  "q.projectType": "¿Qué describe mejor tu proyecto?",
  "q.franchiseStatus": "¿Ya está asociado a una franquicia de fitness?",
  "q.locationStatus": "¿Ya tienes un local para el proyecto?",
  "q.facilityArea": "¿Cuál es la superficie aproximada disponible?",
  "q.projectStage": "¿En qué fase está actualmente su proyecto?",
  "q.openingTimeline": "¿Cuándo planeas inaugurar tu proyecto?",
  "q.investmentBand": "¿Cuál es tu rango de inversión estimado? (USD)",
  "q.investmentHint": "Una estimación es suficiente. Nos ayuda a recomendar la solución adecuada para su proyecto.",
  "q.projectNeed": "¿Qué necesita para su proyecto?",
  "q.projectNeedHint": "Seleccione todas las opciones que apliquen.",
  "q.equipmentListStatus": "¿Ya tiene una lista de equipamiento?",
  "q.logisticsPreference": "¿Cómo desea gestionar la logística internacional?",
  "q.purchaseMethod": "¿Cómo planea actualmente comprar su equipamiento?",
  "q.competitorComparison": "¿Está comparando actualmente otras marcas de equipamiento?",
  "q.competitorBrands": "¿Qué marcas está considerando?",
  "q.decisionRole": "¿Cuál es su rol en este proyecto?",
  "q.country": "País del Proyecto",
  "q.city": "Ciudad",
  "q.firstName": "Nombre",
  "q.lastName": "Apellido",
  "q.company": "Empresa / Nombre del Gimnasio (opcional)",
  "q.email": "Correo Electrónico",
  "q.phone": "WhatsApp / Teléfono",
  "q.preferredContact": "Método de Contacto Preferido",
  "q.notes": "¿Hay algo más que debamos saber sobre su proyecto?",
  "q.optional": "Opcional",
  "q.selectCountry": "Seleccionar país",

  "opt.commercial-gym": "Proyecto de Gimnasio Completo",
  "opt.boutique-gym": "Gimnasio Boutique",
  "opt.pt-studio": "Estudio de Entrenamiento Personal",
  "opt.home-gym": "Gimnasio Privado en Casa",
  "opt.residential-gym": "Gimnasio de Comunidad / Residencial",
  "opt.hotel-resort": "Fitness de Hotel / Resort",
  "opt.corporate-gym": "Gimnasio Corporativo",
  "opt.sports-facility": "Instalación Deportiva / de Rendimiento",
  "opt.franchise": "Franquicia de Gimnasio",
  "opt.other": "Otro",
  "opt.own-franchise": "Sí — ya soy propietario / opero una franquicia",
  "opt.acquiring-franchise": "Sí — estoy adquiriendo una franquicia",
  "opt.evaluating-franchise": "Estoy evaluando oportunidades de franquicia",
  "opt.independent": "No — estoy explorando el negocio del fitness de forma independiente",
  "opt.confirmed": "Sí — ubicación confirmada",
  "opt.negotiating": "Negociando una ubicación actualmente",
  "opt.looking": "Aún buscando una ubicación",
  "opt.up-to-100": "Hasta 100 m²",
  "opt.100-250": "100–250 m²",
  "opt.250-500": "250–500 m²",
  "opt.500-1000": "500–1.000 m²",
  "opt.1000-2000": "1.000–2.000 m²",
  "opt.2000-plus": "2.000+ m²",
  "opt.exploring": "Explorando oportunidades de inversión",
  "opt.initial-planning": "Planificación inicial",
  "opt.business-plan": "Plan de negocio / Planificación de inversión",
  "opt.location-selected": "Ubicación seleccionada",
  "opt.architecture": "Arquitectura / Diseño",
  "opt.construction": "Construcción / Renovación",
  "opt.ready-to-purchase": "Listo para comprar equipamiento",
  "opt.expansion": "Apertura de nueva ubicación / Expansión",
  "opt.within-2": "Dentro de 2 meses",
  "opt.2-4": "2–4 meses",
  "opt.4-6": "4–6 meses",
  "opt.6-12": "6–12 meses",
  "opt.12-plus": "12+ meses",
  "opt.up-to-50k": "Menos de USD 50.000",
  "opt.50-150k": "USD 50.000–150.000",
  "opt.150-300k": "USD 150.000–300.000",
  "opt.300-500k": "USD 300.000–500.000",
  "opt.500k-1m": "USD 500.000–1M",
  "opt.1m-plus": "Más de USD 1M",
  "opt.complete-equipment": "Equipamiento Completo de Gimnasio",
  "opt.strength": "Equipamiento de Fuerza",
  "opt.cardio": "Equipamiento de Cardio",
  "opt.full-project-help": "Necesito ayuda con el proyecto completo",
  "opt.have-list": "Sí — ya tengo una lista de equipamiento",
  "opt.need-review": "Parcialmente — tengo una selección inicial",
  "opt.need-list": "No — necesito la ayuda de YANRE",
  "opt.yanre-coordination": "Quiero la coordinación logística de YANRE",
  "opt.own-partner": "Ya tengo un socio logístico",
  "opt.compare-both": "Quiero comparar ambas opciones",
  "opt.need-guidance": "Necesito orientación antes de decidir",
  "opt.direct": "Directamente al fabricante",
  "opt.dealer": "Distribuidor local de equipamiento de fitness",
  "opt.distributor": "Distribuidor / Importador",
  "opt.comparing": "Comparando diferentes opciones de compra",
  "opt.researching": "Aún investigando proveedores",
  "opt.yes": "Sí",
  "opt.no": "No",
  "opt.owner": "Propietario / Fundador",
  "opt.investor": "Inversor",
  "opt.partner": "Socio",
  "opt.director": "Director / Ejecutivo",
  "opt.manager": "Gerente de Gimnasio",
  "opt.procurement": "Compras / Procurement",
  "opt.architect": "Arquitecto / Diseñador",
  "opt.consultant": "Consultor",
  "opt.trainer": "Personal Trainer",
  "opt.whatsapp": "WhatsApp",
  "opt.phone": "Llamada Telefónica",
  "opt.email": "Correo Electrónico",

  "err.projectType": "Seleccione qué planea construir.",
  "err.franchiseStatus": "Indíquenos su situación respecto a franquicias.",
  "err.locationStatus": "Seleccione el estado de su ubicación.",
  "err.facilityArea": "Seleccione la superficie aproximada de fitness.",
  "err.projectStage": "Seleccione la fase de su proyecto.",
  "err.openingTimeline": "Seleccione el plazo previsto de apertura.",
  "err.investmentBand": "Seleccione su inversión estimada en equipamiento.",
  "err.projectNeed": "Seleccione al menos una necesidad del proyecto.",
  "err.equipmentListStatus": "Seleccione el estado de su lista de equipamiento.",
  "err.logisticsPreference": "Seleccione una preferencia logística.",
  "err.purchaseMethod": "Seleccione su plan de compra.",
  "err.competitorComparison": "Indíquenos si está comparando marcas.",
  "err.decisionRole": "Seleccione su rol en este proyecto.",
  "err.country": "Seleccione el país del proyecto.",
  "err.city": "Indique la ciudad del proyecto.",
  "err.firstName": "Indique su nombre.",
  "err.lastName": "Indique su apellido.",
  "err.email": "Indique un correo electrónico válido.",
  "err.phone": "Indique su número de WhatsApp / teléfono.",
  "err.preferredContact": "Seleccione su método de contacto preferido.",
  "err.privacyConsent": "Acepte el consentimiento de privacidad para enviar su proyecto.",
  "err.submit": "Algo salió mal al enviar su proyecto. Inténtelo de nuevo.",

  "consent.privacy": "Consiento que YANRE FITNESS EUROPE trate mi información para contactarme sobre este proyecto.",
  "consent.marketing": "También deseo recibir ocasionalmente noticias y ofertas de YANRE FITNESS EUROPE. (Opcional)",
  "success.title1": "Proyecto recibido",
  "success.body": "Gracias. Un especialista de YANRE FITNESS EUROPE revisará su proyecto y le contactará a través de su canal preferido.",
  "success.reference": "Referencia",

  // ===== Section copy =====
  "wi.h1a": "¿Busca su próximo negocio?",
  "wi.h1b": "Mire al fitness.",
  "wi.fitnessCol": "Negocio de Fitness",
  "wi.retailCol": "Comercio Minorista Tradicional",
  "wi.f1": "Membresías recurrentes",
  "wi.f2": "Sin inventario de mercancías",
  "wi.f3": "Sin reposición diaria",
  "wi.f4": "Acceso prepagado / recurrente",
  "wi.f5": "Potencial de operación ligera",
  "wi.f6": "Gestión digital",
  "wi.f7": "Equipamiento = activo productivo a largo plazo",
  "wi.r1": "Vender todos los días",
  "wi.r2": "Stock que gestionar",
  "wi.r3": "Compras constantes",
  "wi.r4": "Ingresos transacción por transacción",
  "wi.r5": "Operación con inventario",
  "wi.r6": "Mayor complejidad operativa",
  "wi.r7": "El inventario debe seguir rotando",
  "wi.note": "Una comparación estructural de modelos de negocio — no un juicio sobre otras industrias.",
  "mp.s1": "Ingresos del mercado europeo del fitness en 2025",
  "mp.s2": "Miembros de clubes de fitness en Europa en 2025",
  "mp.s3": "Crecimiento medio global de ingresos de la industria del fitness en 2024",
  "mp.s4": "Margen EBITDA mediano entre los operadores del estudio de benchmarking de la HFA referenciado",
  "mp.opsLabel": "Los grandes operadores se están expandiendo",
  "mp.o1": "Miembros sumados por los 20 mayores operadores de Europa en 2025",
  "mp.o2": "Ingresos combinados de los 20 mayores operadores de Europa en 2025",
  "mp.o3": "Grandes operaciones de M&A en el fitness europeo en 2025",
  "mp.src": "Fuentes: Health & Fitness Association · EuropeActive / Deloitte. Datos de benchmarking de la industria — no son garantía de resultados individuales.",
  "nf.h1a": "No necesita venir de la",
  "nf.h1b": "industria del fitness.",
  "nf.b1": "Usted aporta la inversión y la visión de negocio.",
  "nf.b2": "Nosotros le ayudamos a estructurar la parte del equipamiento del proyecto.",
  "fd.h1a": "Elimine a los intermediarios.",
  "fd.h1b": "No al respaldo.",
  "fd.tradLabel": "Modelo tradicional",
  "fd.directLabel": "YANRE Directo de Fábrica",
  "fd.t1": "Fabricante",
  "fd.t2": "Distribuidor / Importador",
  "fd.t3": "Comerciante / Minorista",
  "fd.t4": "Cliente",
  "fd.customer": "Cliente",
  "fd.trust": "Su contrato de equipamiento y sus pagos son directamente con YANRE FITNESS.",
  "fd.supportLabel": "Directo de fábrica no significa hacerlo solo",
  "fd.s1": "Consultoría Personalizada",
  "fd.s2": "Orientación Técnica",
  "fd.s3": "Selección de Equipamiento",
  "fd.s4": "Apoyo al Proyecto",
  "fd.s5": "Coordinación Logística Opcional",
  "fd.s6": "Apoyo Posventa",
  "fd.s7": "Garantía de Fábrica",
  "pp.h1a": "Un proceso claro.",
  "pp.h1b": "Del proyecto a la posventa.",
  "pp.1.t": "Briefing del Proyecto",
  "pp.1.b": "El cliente explica el espacio, el concepto, la inversión y el calendario.",
  "pp.2.t": "Consultoría YANRE",
  "pp.2.b": "Selección de equipamiento, orientación técnica y configuración del proyecto.",
  "pp.3.t": "Contrato de Fábrica",
  "pp.3.b": "Propuesta final y pedido oficial de equipamiento directamente con YANRE FITNESS.",
  "pp.4.t": "Pago del 30% a Fábrica",
  "pp.4.b": "Anticipo estándar pagado directamente a YANRE FITNESS y el pedido entra en producción.",
  "pp.5.t": "Producción",
  "pp.5.b": "Fabricación y preparación del equipamiento.",
  "pp.6.t": "Pago del 70% a Fábrica",
  "pp.6.b": "Saldo estándar pagado directamente a YANRE FITNESS tras la producción y antes del envío, según el contrato oficial.",
  "pp.7.t": "Envío Internacional",
  "pp.7.b": "El cliente puede usar su propio operador logístico o solicitar coordinación logística.",
  "pp.8.t": "Posventa",
  "pp.8.b": "Apoyo continuo y garantía de fábrica tras la entrega.",
  "pp.payTitle": "El 100% de los pagos del equipamiento se realiza directamente a YANRE FITNESS.",
  "pp.paySub": "Ningún pago de equipamiento se realiza a agentes, consultores o intermediarios externos.",
  "pp.disclaimer": "Estructura de pago estándar mostrada. Las condiciones comerciales y de pago finales se definen en el contrato de venta oficial de YANRE FITNESS.",
  "fe.h1a": "Diseñado para rendir.",
  "fe.h1b": "Construido para destacar.",
  "fe.tagline": "Su equipamiento es parte de su marca.",
  "fe.i0.cat": "Fuerza Selectorizada",
  "fe.i0.series": "73 Tough Series",
  "fe.i0.stmt": "Fuerza selectorizada diseñada para el uso profesional diario.",
  "fe.i1.cat": "Plate Loaded",
  "fe.i1.series": "Plate-Loaded Power",
  "fe.i1.stmt": "Máquinas plate-loaded construidas en torno al movimiento natural.",
  "fe.i2.cat": "Doble Función",
  "fe.i2.series": "C4D Doble Función",
  "fe.i2.stmt": "Dos estaciones en un solo espacio — máxima densidad de entrenamiento.",
  "fe.i3.cat": "Cardio Comercial",
  "fe.i3.series": "Cardio Comercial",
  "fe.i3.stmt": "Cardio construido para entornos comerciales sin pausa.",
  "dd.h1a": "La diferencia",
  "dd.h1b": "está en los detalles.",
  "dd.0.t": "Ingeniería Original",
  "dd.0.s": "Diseño desarrollado por YANRE.",
  "dd.1.t": "Diseño Patentado",
  "dd.1.s": "Diseño de equipamiento original y patentado.",
  "dd.2.t": "Construcción del Chasis",
  "dd.2.s": "Ingeniería de chasis y tubos en primer plano.",
  "dd.3.t": "Diseño de Chasis Curvo",
  "dd.3.s": "Geometría del chasis moldeada en torno al movimiento.",
  "dd.4.t": "Tapicería y Acolchado",
  "dd.4.s": "Tapicería profesional, costuras y acabado.",
  "dd.5.t": "Sistema de Cables / Poleas / Guías",
  "dd.5.s": "Componentes de movimiento de precisión.",
  "dd.6.t": "Biomecánica",
  "dd.6.s": "Pivotes y trayectorias de movimiento diseñados en torno al cuerpo.",
  "dd.7.t": "Construcción de Grado Comercial",
  "dd.7.s": "Construida para durabilidad y uso profesional diario.",
  "bt.0": "Gimnasio Comercial",
  "bt.1": "Club de Fitness Premium",
  "bt.2": "Gimnasio Boutique",
  "bt.3": "Estudio de Personal Training",
  "bt.4": "Gimnasio de Fuerza / Rendimiento",
  "bt.5": "Instalación de Entrenamiento Funcional",
  "bt.6": "Gimnasio Privado Profesional en Casa",
  "bt.7": "Gimnasio Residencial / de Condominio",
  "bt.8": "Hotel / Resort",
  "bt.9": "Fitness Corporativo",
  "bt.10": "Local de Franquicia",
  "wy.h1a": "Diseñado por la experiencia.",
  "wy.h1b": "Construido para el rendimiento.",
  "wy.p1.t": "Fabricación",
  "wy.p1.b": "Fabricación propia de sistemas de fuerza de grado comercial — diseñados y producidos por YANRE, no ensamblados a partir de diseños de terceros.",
  "wy.p2.t": "Ingeniería y Biomecánica",
  "wy.p2.b": "Diseño original desde 1997, con más de 200 patentes que cubren ingeniería de equipamiento y biomecánica del movimiento.",
  "wy.p3.t": "Durabilidad Comercial",
  "wy.p3.b": "Equipamiento construido para el uso profesional diario, certificado según las normas CE, TÜV e ISO.",
  "wy.p4.t": "Desarrollo de Producto",
  "wy.p4.b": "Una gama liderada por el fabricante — desde la 73 Tough Series hasta líneas plate-loaded, máquinas de doble función y cardio comercial.",
  "wy.p5.t": "Experiencia Internacional",
  "wy.p5.b": "La confianza de gimnasios profesionales en más de 110 países, con más de 34.950 proyectos de gimnasios entregados en todo el mundo.",
  "wy.proof0": "Desde 1997",
  "wy.proof1": "200+ Patentes",
  "wy.proof2": "110+ Países",
  "wy.proof3": "CE · TÜV · ISO",
  "wy.proof4": "34.950+ Proyectos",
  "fo.navFactory": "La Fábrica",
  "fo.navFounder": "El Hombre Detrás de la Máquina",
  "fo.h1a": "El Hombre",
  "fo.h1b": "Detrás de",
  "fo.h1c": "la Máquina.",
  "fo.role": "Fundador y Diseñador Jefe",
  "fo.body": "Atleta, ingeniero y fundador de YANRE. Desde 1997, construye máquinas para quienes valoran la ingeniería por encima del marketing.",
  "fo.quote": "“Para entender la máquina, hay que entender al hombre detrás de ella.”",
  "fo.st1.t": "El Comienzo",
  "fo.st1.b": "En 1991, George Yang aún no era fundador — era técnico, reparando máquinas de gimnasio para el Equipo Nacional de Atletas de China. Reparar reveló la verdad; él mismo entrenaba en las máquinas para sentir exactamente dónde fallaban.",
  "fo.st2.t": "El Problema",
  "fo.st2.b": "Incluso las “mejores” marcas del mundo tenían defectos — soldaduras débiles, ángulos deficientes y diseños que ignoraban el cuerpo humano. Las limitaciones que vio dieron forma a una manera completamente distinta de pensar el equipamiento.",
  "fo.st3.t": "La Fundación",
  "fo.st3.b": "En 1997 dejó de corregir los errores de otros y fijó su propio estándar — fundando Yangrui Fitness en Pekín, con el nombre de su hijo. El nombre evolucionó de Yangrui a Yanre y después a YR; el estándar nunca cambió.",
  "fo.st4.t": "El Ingeniero",
  "fo.st4.b": "Se niega a comprometer los materiales: acero calificado Q235 con un mínimo de 3 mm, barras 30CrMnSiA, levas y poleas de POM de baja fricción y cables importados de Japón con capacidad de 1400kg. “Yo mismo entreno en estas máquinas.”",
  "fo.st5.t": "El Diseñador",
  "fo.st5.b": "Su filosofía es limpia y minimalista — el diseño no es cómo se ve, sino cómo funciona. YANRE diseña en lugar de copiar; la 73 Series fue la primera del mundo en usar trayectorias de movimiento independientes, convergentes y divergentes.",
  "fo.st6.t": "La Visión",
  "fo.st6.b": "Una fábrica de artesanos, no un almacén de cajas — pedido mínimo de una unidad, personalización real y apoyo pensado para el décimo año de un gimnasio, no solo para el primer día. Un socio, no un jefe.",
  "fo.m1.t": "Experiencia Técnica Temprana",
  "fo.m1.b": "Técnico del Equipo Nacional de Atletas de China.",
  "fo.m2.t": "Fundación de YANRE",
  "fo.m2.b": "Yangrui Fitness fundada en Pekín.",
  "fo.m3.t": "La 73 Series",
  "fo.m3.b": "Primera del mundo con trayectorias independientes, convergentes y divergentes.",
  "fo.pqA": "“Fabricamos productos con",
  "fo.pqHeart": "corazón",
  "fo.pqB": ", y fabricamos productos con",
  "fo.pqStandard": "estándar",
  "fo.pqEnd": ".”",
  "fo.c1.t": "Materiales",
  "fo.c1.b": "Acero Q235, mínimo de 3 mm. Levas POM. Cables de 1400kg.",
  "fo.c2.t": "Biomecánica",
  "fo.c2.b": "Trayectorias de movimiento diseñadas en torno al cuerpo humano.",
  "fo.c3.t": "Durabilidad",
  "fo.c3.b": "Construido para durar más de 10 años de uso profesional.",
  "fo.c4.t": "Estándar",
  "fo.c4.b": "ISO 20957 como punto de partida — nunca como techo.",
  "cc.h1a": "Gimnasios reales.",
  "cc.h1b": "Negocios reales.",
  "cc.h1c": "YANRE real.",
  "cc.case0.title": "Estética Premium. Instalación Profesional.",
  "cc.case1.title": "Distribución Sencilla. Instalación Sólida.",
  "cc.case2.title": "Estilo Funcional. Equipamiento Profesional.",
  "cc.videoPending": "Vídeo completo del proyecto disponible bajo petición",
  "lg.h1a": "Su equipamiento. Su destino.",
  "lg.h1b": "Su elección.",
  "lg.option": "Opción",
  "lg.o1.t": "Use Su Propio Socio Logístico",
  "lg.o1.b": "Trabaje con el operador logístico en el que ya confía. Preparamos su pedido para la exportación y coordinamos con su socio.",
  "lg.o2.t": "Deje la Coordinación con Nosotros",
  "lg.o2.b": "Solicite la coordinación logística de YANRE según el alcance contratado — de fábrica al puerto de destino.",
  "lg.f1": "Fábrica",
  "lg.f2": "Exportación",
  "lg.f3": "Transporte Marítimo",
  "lg.f4": "Puerto de Destino",
  "lg.disclaimer": "El despacho de aduanas, impuestos, aranceles y servicios de última milla solo se incluyen cuando se contratan explícitamente.",
  "lg.cta": "Incluir Logística en Mi Proyecto",
  "as.h1a": "La relación no termina",
  "as.h1b": "cuando el contenedor zarpa.",
  "as.1.t": "Garantía de Fábrica",
  "as.1.b": "Respaldo de garantía del fabricante para su equipamiento.",
  "as.2.t": "Soporte Técnico",
  "as.2.b": "Asistencia técnica directa, conectada con quienes están detrás del equipamiento.",
  "as.3.t": "Soporte de Repuestos",
  "as.3.b": "Soporte de repuestos a nivel de fabricante para sus máquinas.",
  "as.4.t": "Asistencia Posventa",
  "as.4.b": "Asistencia posventa continua tras la entrega.",

  // Cookie consent & policy
  "ck.title": "Tus opciones de privacidad",
  "ck.desc": "Utilizamos cookies opcionales de análisis y publicidad solo con tu consentimiento. Puedes cambiar o retirar tu elección en cualquier momento.",
  "ck.acceptAll": "Aceptar Todo",
  "ck.reject": "Rechazar No Esenciales",
  "ck.manage": "Gestionar Preferencias",
  "ck.save": "Guardar Preferencias",
  "ck.necessary": "Necesarias",
  "ck.necessaryDesc": "Necesarias para que el sitio web funcione. Siempre activas.",
  "ck.analytics": "Analítica",
  "ck.analyticsDesc": "Estadísticas anónimas de uso que nos ayudan a mejorar este sitio web.",
  "ck.advertising": "Publicidad",
  "ck.advertisingDesc": "Se utilizan para medir campañas y mostrar publicidad relevante.",
  "ck.alwaysOn": "Siempre activas",
  "ck.prefsTitle": "Preferencias de Cookies",
  "ck.policy": "Política de Cookies",
  "ck.privacy": "Política de Privacidad",
  "footer.cookiePrefs": "Preferencias de Cookies",
  "cp.title": "Política de Cookies",
  "cp.updated": "Última actualización: julio de 2026",
  "cp.intro": "Esta página explica cómo YANRE FITNESS EUROPE utiliza cookies y tecnologías similares en este sitio web, y cómo puedes controlarlas.",
  "cp.s1t": "Qué almacenamos",
  "cp.s1b": "Cuando realizas una elección de consentimiento, almacenamos únicamente esa elección (necesarias, analítica, publicidad) en el almacenamiento local de tu navegador. No contiene información personal y solo se usa para recordar tu preferencia entre visitas.",
  "cp.s2t": "Categorías de cookies",
  "cp.s3t": "Google Tag Manager y Modo de Consentimiento",
  "cp.s3b": "Este sitio web carga un contenedor de Google Tag Manager con el Modo de Consentimiento v2 de Google. Todo el almacenamiento opcional (analítica y publicidad) está configurado como \"denied\" por defecto y solo se activa tras tu consentimiento explícito. No hay etiquetas de análisis ni publicidad instaladas directamente en este sitio web.",
  "cp.s4t": "Gestiona tu consentimiento",
  "cp.s4b": "Puedes cambiar o retirar tu consentimiento en cualquier momento desde el enlace \"Preferencias de Cookies\" en el pie de página. La retirada tiene efecto inmediato.",
  "cp.s5t": "Contacto",
  "cp.privacyT": "Privacidad",
  "cp.privacyB": "Nuestra Política de Privacidad completa está en preparación. Para cualquier pregunta o solicitud sobre tus datos personales, contáctanos en el email indicado arriba.",
  "cp.back": "Volver al Inicio",

  "q.fullName": "Nombre Completo",
  "opt.upgrade-expand": "Renovación / Ampliación de un Gimnasio Existente",
  // ===== PERSONAL TRAINER STUDIO (pts.*) — es =====
  "pts.seo.title": "Estudio de Entrenador Personal — Equipamiento de Gimnasio Profesional | YANRE FITNESS",
  "pts.seo.description": "Monta tu propio estudio de entrenamiento con equipamiento profesional YANRE, directo del fabricante. Paquetes de inicio inteligentes, planificación del espacio y soporte directo de fábrica.",
  "pts.nav.talk": "Hablar con un Especialista",
  "pts.header.cta": "Crear Mi Estudio",
  "pts.hero.label": "Estudio de Entrenador Personal",
  "pts.hero.line1": "Tu Estudio.",
  "pts.hero.line2": "Tus Clientes.",
  "pts.hero.line3": "Tu Negocio.",
  "pts.hero.subhead": "Monta tu estudio de entrenamiento profesional con YANRE.",
  "pts.hero.copy": "Desde tu primer estudio privado hasta un centro premium de entrenamiento personal — equipamiento profesional, planificación inteligente del espacio y soporte directo del fabricante.",
  "pts.hero.ctaPrimary": "Crear Mi Estudio",
  "pts.hero.ctaSecondary": "Hablar con un Especialista",
  "pts.hero.trust.0": "Calidad Comercial",
  "pts.hero.trust.1": "Directo del Fabricante",
  "pts.hero.trust.2": "Garantía de Fábrica",
  "pts.hero.trust.3": "Soporte Logístico",
  "pts.journey.label": "La Transición",
  "pts.journey.h2a": "De Entrenador Personal",
  "pts.journey.h2b": "a Dueño de Estudio.",
  "pts.journey.copy": "Entrenar clientes en el gimnasio de otro construye su negocio. Tu propio estudio construye el tuyo — tu espacio, tus relaciones con los clientes, tu marca, tu activo. La independencia empieza con una sala y el equipamiento adecuado.",
  "pts.journey.0": "Entrenador Personal",
  "pts.journey.1": "Tu Propio Estudio",
  "pts.journey.2": "Tus Propios Clientes",
  "pts.journey.3": "Tu Propia Marca",
  "pts.journey.4": "Tu Propio Negocio",
  "pts.journey.direct": "Directo del Fabricante.",
  "pts.journey.directCopy": "Monta tu estudio con equipamiento profesional comprado directamente a YANRE — el fabricante que diseña y produce cada máquina.",
  "pts.journey.note": "Sin promesas, sin atajos — solo la estructura para convertir tu oficio en un negocio propio.",
  "pts.pkg.label": "Dos Formas de Empezar",
  "pts.pkg.h2a": "Empieza con inteligencia.",
  "pts.pkg.h2b": "Crece a tu ritmo.",
  "pts.pkg.intro": "Un estudio profesional empieza con un paquete de equipamiento cuidadosamente seleccionado — y crece con el tiempo. Cada composición se personaliza según tu espacio, metodología de entrenamiento y nivel de inversión.",
  "pts.pkg.tag": "Paquete",
  "pts.pkg.starter.name": "Starter",
  "pts.pkg.starter.pos": "Todo lo que necesitas para abrir un estudio de entrenamiento privado y profesional.",
  "pts.pkg.starter.i0": "Primer estudio",
  "pts.pkg.starter.i1": "Entrenadores personales",
  "pts.pkg.starter.i2": "Espacios pequeños",
  "pts.pkg.starter.i3": "Entrenamiento 1 a 3",
  "pts.pkg.starter.i4": "Entrenamiento semiprivado",
  "pts.pkg.starter.concept": "Una combinación cuidadosamente seleccionada de máquinas de musculación esenciales, equipamiento funcional y pesos libres.",
  "pts.pkg.starter.cta": "Crear Mi Estudio Starter",
  "pts.pkg.studiopro.name": "Studio Pro",
  "pts.pkg.studiopro.pos": "Una configuración profesional completa para un negocio premium de entrenamiento personal.",
  "pts.pkg.studiopro.i0": "Entrenadores personales establecidos",
  "pts.pkg.studiopro.i1": "Estudios premium",
  "pts.pkg.studiopro.i2": "Mayor capacidad de clientes",
  "pts.pkg.studiopro.i3": "Entrenamiento en grupos reducidos",
  "pts.pkg.studiopro.i4": "Entrenamiento de rendimiento",
  "pts.pkg.studiopro.concept": "Una combinación más completa de máquinas de musculación, equipamiento funcional, pesos libres y cardio.",
  "pts.pkg.studiopro.cta": "Crear Mi Studio Pro",
  "pts.pkg.idealFor": "Ideal para",
  "pts.pkg.conceptLabel": "Concepto de equipamiento",
  "pts.pkg.quote": "Pide tu propuesta de proyecto",
  "pts.pkg.note": "Sin precios fijos online — cada estudio se presupuesta como un proyecto, compuesto según tu espacio, metodología y nivel de inversión.",
  "pts.eq.label": "Hecho para Entrenar de Verdad",
  "pts.eq.h2a": "Calidad comercial.",
  "pts.eq.h2b": "Construido para uso profesional diario.",
  "pts.eq.copy": "Las mismas líneas de equipamiento que sirven a gimnasios comerciales — estructuras diseñadas, movimiento patentado y durabilidad probada en fábrica — escaladas de forma inteligente para un estudio de entrenamiento privado.",
  "pts.eq.strength": "Musculación",
  "pts.eq.functional": "Entrenamiento Funcional",
  "pts.eq.freeweights": "Pesos Libres",
  "pts.eq.benches": "Bancos y Racks",
  "pts.eq.cable": "Estaciones de Poleas",
  "pts.eq.cardio": "Cardio",
  "pts.eq.alt.strength": "Equipamiento de musculación profesional YANRE para estudios de entrenamiento personal",
  "pts.eq.alt.functional": "Equipamiento de entrenamiento funcional YANRE para estudios de fitness profesionales",
  "pts.eq.alt.freeweights": "Equipamiento profesional de pesos libres YANRE para estudios de entrenamiento personal",
  "pts.eq.alt.benches": "Bancos y racks profesionales YANRE para estudios de entrenamiento personal",
  "pts.eq.alt.cable": "Estaciones de poleas profesionales YANRE para estudios de entrenamiento personal",
  "pts.eq.alt.cardio": "Equipamiento de cardio profesional YANRE para estudios de entrenamiento personal",
  "pts.space.label": "Planificación del Espacio",
  "pts.space.h2a": "Tu espacio.",
  "pts.space.h2b": "Tu proyecto.",
  "pts.space.copy": "No hay dos estudios iguales. La selección de equipamiento y el layout se diseñan en torno a tu realidad — no un paquete fijo de catálogo.",
  "pts.space.f0": "Superficie disponible",
  "pts.space.f1": "Metodología de entrenamiento",
  "pts.space.f2": "Número de clientes simultáneos",
  "pts.space.f3": "Nivel de inversión",
  "pts.space.f4": "Compra Directa de Fábrica",
  "pts.space.f4d": "Equipamiento profesional YANRE sin capas innecesarias de distribuidores.",
  "pts.space.f5": "Estudio Listo para Operar",
  "pts.space.f5d": "Equipamiento profesional, layout inteligente y un concepto de estudio completo, listo para el negocio.",
  "pts.space.cta": "Empezar Mi Proyecto de Estudio",
  "pts.direct.label": "Directo del Fabricante",
  "pts.direct.h2a": "Sin intermediarios.",
  "pts.direct.h2b": "Sin concesiones.",
  "pts.direct.copy": "YANRE es el fabricante — diseña y produce su propio equipamiento profesional desde 1997. Tu proyecto, tu contrato de equipamiento y tu garantía viven directamente con la fábrica que construye tus máquinas.",
  "pts.direct.p0": "Equipamiento de calidad comercial",
  "pts.direct.p1": "Relación directa con el fabricante",
  "pts.direct.p2": "Garantía respaldada por fábrica",
  "pts.direct.p3": "Soporte logístico internacional",
  "pts.direct.p4": "Consultoría de proyecto",
  "pts.direct.p5": "Soporte postventa",
  "pts.process.label": "Cómo Funciona",
  "pts.process.h2a": "Un proceso claro.",
  "pts.process.h2b": "De la idea al día de apertura.",
  "pts.process.1.t": "Consulta",
  "pts.process.1.b": "Te entendemos a ti, tu espacio, tu concepto y tu nivel de inversión.",
  "pts.process.2.t": "Proyecto",
  "pts.process.2.b": "Juntos definimos la selección de equipamiento y el layout del estudio.",
  "pts.process.3.t": "Pedido — 30%",
  "pts.process.3.b": "Confirma el proyecto e inicia la producción con un pago del 30% a la fábrica.",
  "pts.process.4.t": "Producción",
  "pts.process.4.b": "YANRE fabrica y prepara tu equipamiento.",
  "pts.process.5.t": "70% Antes del Envío",
  "pts.process.5.b": "El saldo final se liquida antes del envío, según el contrato oficial.",
  "pts.process.6.t": "Envío",
  "pts.process.6.b": "Logística internacional coordinada para tu proyecto.",
  "pts.process.7.t": "Postventa",
  "pts.process.7.b": "Soporte respaldado por fábrica tras la instalación.",
  "pts.monetize.label": "Monetiza las Horas Libres del Estudio",
  "pts.monetize.h2a": "Haz que tu estudio trabaje",
  "pts.monetize.h2b": "incluso cuando no estás.",
  "pts.monetize.copy": "Tu estudio no tiene por qué generar valor solo cuando entrenas a tus propios clientes. Las horas libres pueden convertirse en una oportunidad de ingresos adicional, dando a otros entrenadores personales acceso a tu espacio de entrenamiento profesional.",
  "pts.monetize.clients": "Tus Clientes",
  "pts.monetize.clientsSub": "Tus propias sesiones de entrenamiento",
  "pts.monetize.hours": "Horas Disponibles",
  "pts.monetize.hoursSub": "Otros entrenadores usan tu estudio",
  "pts.monetize.revenue": "Otra Fuente de Ingresos",
  "pts.monetize.revenueSub": "Aprovecha mejor tu espacio a lo largo del día",
  "pts.monetize.closeA": "El estudio es tuyo.",
  "pts.monetize.closeB": "Tú controlas la agenda.",
  "pts.form.label": "Empieza Tu Proyecto de Estudio",
  "pts.form.h2a": "Cuéntanos sobre",
  "pts.form.h2b": "tu estudio.",
  "pts.form.sub": "Dos minutos. Un especialista responde con una propuesta concreta de equipamiento para tu espacio y presupuesto.",
  "pts.form.intro.sub1": "4 PASOS RÁPIDOS.",
  "pts.form.intro.sub2": "UNA SOLUCIÓN COMPLETA PARA TU ESTUDIO.",
  "pts.form.intro.support": "Cuéntanos tu estudio en solo 4 pasos sencillos. Nuestro equipo entenderá tus necesidades y te ayudará a construir la solución adecuada — con suministro directo de fábrica de YANRE FITNESS China, consultoría profesional y soporte posventa.",
  "pts.form.intro.minute": "1 MINUTO PARA COMPLETAR",
  "pts.form.progress": "Paso",
  "pts.form.back": "Atrás",
  "pts.form.continue": "Continuar",
  "pts.form.submit": "Recibir Mi Proyecto de Estudio",
  "pts.form.sending": "Enviando…",
  "pts.form.err.step": "Completa los campos obligatorios para continuar.",
  "pts.form.err.submit": "Algo salió mal al enviar tu proyecto. Inténtalo de nuevo.",
  "pts.success.title": "Tu proyecto de estudio ha sido recibido.",
  "pts.success.body": "Un especialista de YANRE revisará tu información y te contactará para hablar sobre tu estudio, necesidades de equipamiento y próximos pasos.",
  "pts.success.reference": "Referencia",
  "pts.success.cta": "Visitar YANRE FITNESS",
  "pts.q.areYou": "¿Qué te describe mejor?",
  "pts.q.planning": "¿Qué estás planeando?",
  "pts.q.package": "¿Qué paquete de estudio te interesa?",
  "pts.q.location": "¿Ya tienes un local?",
  "pts.q.size": "Tamaño aproximado del estudio:",
  "pts.q.timeline": "¿Cuándo planeas inaugurar tu estudio?",
  "pts.q.investment": "¿Cuál es tu presupuesto de inversión estimado? (USD)",
  "pts.q.needs": "¿Qué necesitas?",
  "pts.q.needsHint": "Selecciona todas las que apliquen.",
  "pts.q.country": "País",
  "pts.q.city": "Ciudad",
  "pts.q.fullName": "Nombre Completo",
  "pts.q.email": "Email",
  "pts.q.phone": "Teléfono / WhatsApp",
  "pts.q.company": "Empresa / Nombre del Estudio (opcional)",
  "pts.q.selectCountry": "Selecciona el país",
  "pts.step.1": "Estudio",
  "pts.step.2": "Espacio",
  "pts.step.3": "Inversión",
  "pts.step.4": "Contacto",
  "pts.step.5": "Necesidades de Equipamiento",
  "pts.step.6": "Contacto",
  "pts.opt.role.personal-trainer": "Entrenador Personal",
  "pts.opt.role.sc-coach": "Entrenador de Fuerza y Acondicionamiento",
  "pts.opt.role.studio-owner": "Dueño de Estudio",
  "pts.opt.role.investor-entrepreneur": "Inversor / Emprendedor",
  "pts.opt.role.other": "Otro",
  "pts.opt.plan.first-studio": "Abrir mi primer estudio",
  "pts.opt.plan.upgrade-studio": "Mejorar mi estudio actual",
  "pts.opt.plan.another-location": "Abrir otra ubicación",
  "pts.opt.pkg.starter": "STARTER",
  "pts.opt.pkg.studio-pro": "STUDIO PRO",
  "pts.opt.pkg.need-help": "Necesito ayuda para elegir",
  "pts.opt.loc.confirmed": "Sí",
  "pts.opt.loc.looking": "Buscando actualmente",
  "pts.opt.loc.not-yet": "Todavía no",
  "pts.opt.size.under-50": "Menos de 50 m²",
  "pts.opt.size.50-100": "50–100 m²",
  "pts.opt.size.100-200": "100–200 m²",
  "pts.opt.size.over-200": "Más de 200 m²",
  "pts.opt.size.undefined": "Aún no definido",
  "pts.opt.time.1-2": "1–2 meses",
  "pts.opt.time.2-4": "2–4 meses",
  "pts.opt.time.4-6": "4–6 meses",
  "pts.opt.time.6-plus": "Más de 6 meses",
  "pts.opt.inv.under-10k": "Menos de 10.000",
  "pts.opt.inv.10-20k": "10.000–20.000",
  "pts.opt.inv.20-40k": "20.000–40.000",
  "pts.opt.inv.40-80k": "40.000–80.000",
  "pts.opt.inv.80k-plus": "Más de USD 80.000",
  "pts.opt.need.complete-studio-equipment": "Equipamiento Completo de Estudio",
  "pts.opt.need.strength": "Máquinas de Musculación",
  "pts.opt.need.functional": "Entrenamiento Funcional",
  "pts.opt.need.cardio": "Equipamiento de Cardio",
  "pts.opt.need.full-project-help": "Necesito ayuda con el proyecto completo",
  "pts.opt.role.gym-owner-operator": "Propietario / Operador de Gimnasio",
  "pts.opt.inv.under-20k": "Menos de USD 20.000",
  "pts.opt.inv.20-30k": "USD 20.000–30.000",
  "pts.opt.inv.30-50k": "USD 30.000–50.000",
  "pts.opt.inv.50-80k": "USD 50.000–80.000",
  "err.phoneInvalid": "Introduce un número de teléfono válido para el país seleccionado.",
};
